import { Component, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { ICONS } from '../../../constants/constants';

@Component({
  selector: 'app-input-row',
  templateUrl: './input-row.component.html',
  styleUrls: ['./input-row.component.scss'],
})
export class InputRowComponent {
  protected readonly ICONS = ICONS;

  @Input() public fc: UntypedFormControl;
  @Input() public label: string;
  @Input() public labelInfo: string;
  @Input() public labelDescription: string;
  @Input() public hasBorderTop: boolean = true;
}
